/* eslint-disable global-require */

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '',
      load: () => import(/* webpackChunkName: 'home' */ './home'),
    },
    {
      path: ['/testet', '/testet/:id'],
      load: () => import(/* webpackChunkName: 'testet' */ './testet'),
    },
    {
      path: '/faktabank',
      load: () => import(/* webpackChunkName: 'faktabank' */ './faktabank'),
    },
    {
      path: '/om-kostradsguiden',
      load: () => import(/* webpackChunkName: 'about' */ './about'),
    },

    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Kostrådsguiden'}`;
    route.description =
      route.description ||
      `En guide om hur du använder Livsmedelsverkets kostråd i märkning och marknadsföring`;

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js